import { saveAs } from 'file-saver';
import { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import '../css/DataTable.css';

const DataTable = ({ columns, data }) => {
  const [globalFilter, setGlobalFilter] = useState('');
  const [currentPage, setCurrentPage] = useState(0);
  const rowsPerPage = 5;
  const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleDownloadExcel = () => {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(blob, 'data.xlsx');
  };

  const handleSort = (columnId) => {
    let direction = 'asc';
    if (sortConfig.key === columnId && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key: columnId, direction });
  };

  const filteredData = data.filter(row => {
    if (!globalFilter) return true;
    const lowerCaseFilter = globalFilter.toLowerCase();

    return columns.some(column => {
      const key = column.accessor;
      if (key === 'funciones' || key === 'imagen' || key === 'email') return false;

      const value = row[key];
      return value?.toString().toLowerCase().includes(lowerCaseFilter);
    });
  });

  const sortedData = [...filteredData].sort((a, b) => {
    if (!sortConfig.key) return 0;
    if (a[sortConfig.key] < b[sortConfig.key]) return sortConfig.direction === 'asc' ? -1 : 1;
    if (a[sortConfig.key] > b[sortConfig.key]) return sortConfig.direction === 'asc' ? 1 : -1;
    return 0;
  });

  const pageCount = Math.ceil(sortedData.length / rowsPerPage);
  const paginatedData = sortedData.slice(
    currentPage * rowsPerPage,
    currentPage * rowsPerPage + rowsPerPage
  );

  return (
    <div className="data-table-container">
      <div className="d-flex align-items-center mb-3">
        <input
          type="text"
          placeholder="Buscar..."
          value={globalFilter}
          onChange={e => {
            setGlobalFilter(e.target.value);
            setCurrentPage(0);
          }}
          className="form-control me-3"
        />
        <div className='col'>
          <button
            onClick={handleDownloadExcel}
            className="btn btn-download"
            style={{ width: "30px", height: "30px", padding: "0" }}
            title="Descargar Excel"
          >
            <i className="fa-solid fa-download"></i>
          </button>
        </div>
      </div>

      {isMobile ? (
        // VISTA EN CARDS PARA MÓVIL
        paginatedData.map((row, rowIndex) => (
          <div key={rowIndex} className="card mb-3 shadow-sm mx-auto" style={{ maxWidth: '540px', width: '100%' }}>
            <div className="card-body">
              <div className="row">
                {columns.map(column => (
                  <div key={column.accessor} className="col-12 col-md-6 mb-3">
                    {column.accessor !== 'funciones' ? (
                      <div className="d-flex justify-content-between border-bottom pb-1">
                        <span className="text-muted small text-start">{column.Header}</span>
                        <span className="fw-semibold text-end">{row[column.accessor]}</span>
                      </div>
                    ) : (
                      <div>{row[column.accessor]}</div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>

        ))
      ) : (
        // VISTA EN TABLA PARA ESCRITORIO
        <div className="table-responsive">
          <table className="data-table table table-hover">
            <thead>
              <tr>
                {columns
                  .filter(column => column.accessor !== 'email')
                  .map(column => (
                    <th key={column.accessor}>
                      <div className="d-flex align-items-center">
                        <span className="me-2">{column.Header}</span>
                        {column.accessor !== 'funciones' && column.accessor !== 'imagen' && (
                          <button
                            onClick={() => handleSort(column.accessor)}
                            className="btn btn-sm btn-link p-0"
                          >
                            {sortConfig.key === column.accessor
                              ? sortConfig.direction === 'asc'
                                ? '🔼'
                                : '🔽'
                              : '↕'}
                          </button>
                        )}
                      </div>
                    </th>
                  ))}
              </tr>
            </thead>
            <tbody>
              {paginatedData.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {columns
                    .filter(column => column.accessor !== 'email')
                    .map(column => (
                      <td key={column.accessor}>{row[column.accessor]}</td>
                    ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div className="pagination mt-3 d-flex justify-content-between align-items-center">
        <button onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 0}>
          Anterior
        </button>
        <span>
          Página <strong>{currentPage + 1} de {pageCount}</strong>
        </span>
        <button onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage >= pageCount - 1}>
          Siguiente
        </button>
      </div>
    </div>
  );
};

export default DataTable;
